import React, { useState, useEffect } from 'react';
import { Grid, Header, Icon, Loader, Popup } from 'semantic-ui-react';
import { ButtonLink, EmptyListPlaceholder } from 'dyl-components';
import IntegrationForm from './subcomponents/IntegrationForm';
import IntegrationTable from './subcomponents/IntegrationTable';
import oauthActions from 'actions/oauth';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { USER_PERMISSIONS } from 'dyl-components';
import RestrictedView from 'shared/RestrictedView';

import './index.scss';

const IntegratedApps = () => {
    const { id } = useParams();
    const dispatch = useDispatch();
    const { integrations = [], isReadingIntegrations, integrationBeingDeleted, isReactivatingAnIntegration } = useSelector(state => state.oauth_integrations);

    const [isIntegrationFormOpen, setFormOpen] = useState(false);
    const active = useSelector((state) =>
        state.user.userProfile.active
    )
    useEffect(() => {
        dispatch(oauthActions.getIntegrations({ scopes: `email,calendar`, include_disabled: true, user_id: id  }));
    }, [dispatch, id]);

    return (            
        <RestrictedView userPermission={USER_PERMISSIONS.USER_PROFILE_PREFERENCES_VIEW} type="restricted" userRestrict>
            <Grid className='IntegrationApps'>
                <Grid.Row>
                    <Grid.Column width={5}>
                        <Header size='medium' color='blue' >
                            <RestrictedView userPermission={USER_PERMISSIONS.USER_PROFILE_PREFERENCES_ADD} type="disabled" userRestrict>
                                <Popup
                                    trigger={
                                            <Icon name='plus circle' link  disabled={!active}/>
                                    }
                                    content={
                                        <IntegrationForm onClose={() => { setFormOpen(false) }} />
                                    }
                                    className='IntegrationPopup'
                                    basic
                                    pinned
                                    flowing
                                    position='bottom left'
                                    on='click'
                                    open={isIntegrationFormOpen}
                                    onOpen={() => { setFormOpen(true) }}
                                    onClose={() => { setFormOpen(false) }}
                                />
                            </RestrictedView>
                            <Header.Content>Integration</Header.Content>
                        </Header>
                    </Grid.Column>
                    <Grid.Column width={6} textAlign='right'>
                        <Popup
                            trigger={<Icon className='fa-solid fa-circle-info' color='blue' size='large' />}
                            content='To delete a primary email/calendar, first select a different primary'
                            position='left center'
                            inverted
                            flowing
                        />
                    </Grid.Column>
                </Grid.Row>
                <Grid.Row>
                    <Grid.Column width={11}>
                        <Loader active={isReadingIntegrations || integrationBeingDeleted || isReactivatingAnIntegration} />
                        <IntegrationTable active={active}/>
                        {integrations.length === 0
                            &&
                            <EmptyListPlaceholder title={'No Integration Created Under User'}
                                subtitle={<span>Add an Integration by clicking on the
                                    <RestrictedView userPermission={USER_PERMISSIONS.USER_PROFILE_PREFERENCES_ADD} type="disabled" userRestrict>
                                        <ButtonLink onClick={() => { setFormOpen(true); }} disabled={!active} >+ Integration</ButtonLink>
                                    </RestrictedView>
                                    button on the top-left corner</span>} />
                        }

                    </Grid.Column>
                </Grid.Row>
            </Grid>
        </RestrictedView>
    )
}

export default IntegratedApps;
